<template>
  <modal id="galleryReviewModal">
    <template slot="header">
      <button type="button" class="close close-popup" data-dismiss="modal" aria-label="Close" @click="resetModal()">
        <span aria-hidden="true">×</span>
      </button>
      <h2 class="modal-title">Request Review</h2>
    </template>

    <div class="alert alert-danger color-error msgblock" v-if="formErrors">
      {{ formErrors }}
    </div>
    <div class="alert alert-danger msgblock" v-show="errors.any()">
      <span v-for="(error, index) in errors.all()" :key="index">
        {{ error }} <br />
      </span>
    </div>
    <div class="alert alert-success msgblock" v-if="formSuccess">
      {{ formSuccess }}
    </div>

    <form enctype="multipart/form-data">
      <div class="form-group">
        <label>Project Name:</label>
        <input type="text" :value="project.name || ''" class="form-control">
      </div>
      <div class="form-group">
        <label>To:</label>
        <input type="text" name="recipient" placeholder="name@example.com" class="form-control"
          v-model="form.client_email" required>
        <span v-show="errors.has('recipient')" class="text-danger">{{ errors.first('recipient') }}</span>
      </div>
      <div class="form-group">
        <label>Message (Optional):</label>
        <textarea rows="5" class="form-control" v-model="form.message">
        </textarea>
      </div>
      <div class="form-group text-center">
        <button v-on:click.prevent="sendReview" class="btn btn-blue btn-lg" :disabled="errors.any() || processing">
          Send
        </button>
        <button data-dismiss="modal" @click.prevent="resetModal()" class="btn btn-black btn-lg">
          Cancel
        </button>
      </div>
    </form>
  </modal>
</template>

<script>
export default {
  props: {
    project: Object,
  },
  data() {
    return {
      form: {
        client_email: '',
        message: '',
      },
      processing: false,
      formSuccess: null,
      formErrors: null,
    };
  },
  methods: {
    resetModal() {
      this.form.client_email = '';
      this.form.message = '';
      this.formSuccess = null;
      this.formErrors = null;
    },
    async sendReview() {
      const projectID = this.project.id;
      const domain = this.project.domain;

      try {
        let success = await this.$validator.validateAll();

        if (!success) {
          this.$set(this.formErrors, message, 'Please provide a recipient.');
          return false;
        }

        await axios.post(
          '/api/proxify/domains/' +
          domain +
          '/projects/' +
          projectID +
          '/review',
          this.form
        );
        this.$parent.$emit('review-requested', this.project);
        this.resetModal();
        this.formSuccess = 'Your review request has been sent!';
      } catch (error) {
        const status = error.response.status;
        const apiMessage = error.response.data.message;
        if (status === 400 && apiMessage.includes('not currently approved')) {
          this.formErrors =
            'This project must be approved before a review request can be submitted.';
        } else if (status === 400) {
          this.formErrors = 'This project already has a review.';
        } else {
          this.formErrors =
            'An error occurred while trying to send your request.';
        }
      }
    },
  },
};
</script>
